import { render } from "./Main.vue?vue&type=template&id=36e2c688&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=36e2c688&scoped=true&lang=scss"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e2c688"]])

export default __exports__